module.exports = __webpack_public_path__ + "images/sgp/SGPHero/medium-self-storage-hero.webp";